//images
import blackSkirt from '../assets/images/products/blackSkirt.jpg';
import pinkSkirt from '../assets/images/products/pinkSkirt.jpg';
import redSkirt from '../assets/images/products/redSkirt.jpg';
import blackWhiteSkirt from '../assets/images/products/blackWhiteSkirt.jpg';
import skirtWithFlowers from '../assets/images/products/skirtWithFlowers.jpg';
import liteblueShirt from '../assets/images/products/liteblueShirt.jpg';
import blueShirt from '../assets/images/products/blueShirt.jpg';
import brownPants from '../assets/images/products/brownPants.jpg';
import creamPants from '../assets/images/products/creamPants.jpg';
import greenPants from '../assets/images/products/greenPants.jpg';
import jeans from '../assets/images/products/jeans.jpg';
import pisotivityShirt from '../assets/images/products/pisotivityShirt.jpg';
import shirtBlackWhite from '../assets/images/products/shirtBlackWhite.jpg';
import shirtLongSleeves from '../assets/images/products/shirtLongSleeves.jpg';
import whiteShirt from '../assets/images/products/whiteShirt.jpg';
import wightPants from '../assets/images/products/wightPants.jpg';


export const PRODUCTS_IMAGES = {
    blackSkirt: blackSkirt,
    pinkSkirt: pinkSkirt,
    redSkirt: redSkirt,
    blackWhiteSkirt: blackWhiteSkirt,
    skirtWithFlowers: skirtWithFlowers,
    liteblueShirt: liteblueShirt,
    blueShirt: blueShirt,
    brownPants: brownPants,
    creamPants: creamPants,
    greenPants: greenPants,
    jeans: jeans,
    pisotivityShirt: pisotivityShirt,
    shirtBlackWhite: shirtBlackWhite,
    shirtLongSleeves: shirtLongSleeves,
    whiteShirt: whiteShirt,
    wightPants: wightPants
}
export const PRODUCTS_SIZES = {
    blackSkirt: ["X", "L", "XL", "XXL"],
    pinkSkirt: ["X", "M", "XL"],
    redSkirt: ["S", "X", "XXL"],
    blackWhiteSkirt: ["X", "L", "M", "XXL"],
    skirtWithFlowers: ["S", "M", "XL"],
    liteblueShirt: ["S", "X", "XXL"],
    blueShirt: ["X", "L", "XL", "XXL"],
    brownPants: ["X", "M", "XL"],
    creamPants: ["S", "X", "XXL"],
    greenPants: ["S", "M", "XL"],
    jeans: ["S", "X", "XXL"],
    pisotivityShirt: ["S", "M", "XL"],
    shirtBlackWhite: ["S", "X", "XXL"],
    shirtLongSleeves: ["S", "M", "XL"],
    whiteShirt: ["S", "X", "XXL"],
    wightPants: ["S", "M", "XL"]
}
export const PRODUCTS_PRICES = {
    blackSkirt: 15.0,
    pinkSkirt: 20.4,
    redSkirt: 18.7,
    blackWhiteSkirt: 22.5,
    skirtWithFlowers: 22.4,
    liteblueShirt: 20.1,
    blueShirt: 17.3,
    brownPants: 30.4,
    creamPants: 35.5,
    greenPants: 30.1,
    jeans: 33.3,
    pisotivityShirt: 15.8,
    shirtBlackWhite: 20.3,
    shirtLongSleeves: 29.4,
    whiteShirt: 25.1,
    wightPants: 30.0
}